export class PostUbsHealthPromotionSmsEmailRequest {
    public phone: string | null = null;
    public email: string | null = null;
    public imc: number | null = null;
    public degreeImc: string = '';
    public referenceImc: string = '';
    public systolicPressure: number | null = null;
    public diastolicPressure: number | null = null;
    public degreePressure: string = '';
    public referencePressure: string = '';
    public counselingTitle: string = '';
    public counseling: string = '';
    public timeZoneValue: number | null = null;
    public counselingDescription: string = '';
    public dateConsulting: Date | null = null;
    public imcCathegory: number | null = null;
    public paCathegory: number | null = null;
}